export const productosRouteMap = {
  gestion: {
    path: '/productos/gestion',
    name: 'Gestión de Servicios',
  },
  nuevo: {
    path: '/productos/nuevo',
    name: 'Nuevo Servicio',
  },
  modificar: {
    path: '/productos/modificar',
    name: 'Modificar Servicio',
  },
}
